import state from '../../../matrizCompatibilidad/state';
import { defaultSga, pictos, defaultDataToPictograms } from './state';

/**
 * Mutación que carga la informacion sga del sistema al formulario.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} jsonSga contiene la informacion sga del sistema.
 */
export function cargarJsonSga(state, jsonSga) {
    state.jsonSga = jsonSga;

    state.fisicos = state.jsonSga.fisicos;
    state.salud = state.jsonSga.salud;
    state.ambiental = state.jsonSga.ambiental;
    state.peligrosas = state.jsonSga.peligrosas;
}

/**
 * Mutación que carga las frases H del sga con sus respectivos códigos
 *
 * @export
 * @param {*} state
 * @param {*} codigos
 */
export function setFrasesHSga(state, codigos) {
    state.frasesHSga = codigos;
}

/**
 * Mutación que carga la informacion sga del producto químico al formulario.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} sga contiene la informacion sga del producto químico.
 */
export function setSga(state, sga) {
    state.selectedSga = sga;

    state.guardado = !!sga.categoriasfisicas.length && !!sga.categoriassalud.length && !!sga.categoriasambiental.length && !!sga.categoriasNpeligrosas.length
}

/**
 * Mutación que carga la informacion de los pictogramas sga del producto químico.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} pictogramas contiene la información de los pictogramas sga del producto químico.
 */
export function setSgaPictogramas(state, pictogramas) {
    state.pictogramas = pictogramas;
}

/**
 * Mutación que carga la informacion de las frases sga del producto químico.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} frases contiene la información de las frases sga del producto químico.
 */
export function setSgaFrases(state, frases) {
    state.Frases = frases;

    state.Medidas.medidah4x6 = state.Frases.medidas[0][0];
    state.Medidas.medidap4x6 = state.Frases.medidas[0][1];
    state.Medidas.medidah7x10 = state.Frases.medidas[1][0];
    state.Medidas.medidap7x10 = state.Frases.medidas[1][1];
    state.Medidas.medidah18x10 = state.Frases.medidas[2][0];
    state.Medidas.medidap18x10 = state.Frases.medidas[2][1];
    state.Medidas.medidah21x18 = state.Frases.medidas[3][0];
    state.Medidas.medidap21x18 = state.Frases.medidas[3][1];

}

/**
 * Mutación que carga la información del idioma.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} idioma contiene la información del idioma.
 */
export function cambiarIdioma(state, idioma) {
    state.idioma = idioma;
}

/**
 * Mutación que carga la información de la versión de SGA.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} version contiene la información de las versiones SGA.
 */
export function cambiarVersion(state, version) {
    state.version = version;
}

/**
 * Mutación que cambia el tipo de frases SGA.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} tipo contiene la información de los tipos de frases.
 */
export function cambiarTipo(state, tipo) {
    state.tipo = tipo;
}

/**
 * Mutación para limpiar los campos pertenecientes a empresa.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 */
export function limpiarEmpresa(state) {
    state.filtro.empresa = '';
    state.tipo.valor = 0;
}

/**
 * Mutación para cambiar la empresa en SGA.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} empresa contiene la información de las empresas.
 */
export function cambiarEmpresa(state, empresa) {
    state.filtro.empresa = empresa;
}

export function establecerEmpresas(state, empresas) {
    state.empresas = empresas;
}

export function establecerCargandoDatosSelect(state, cargando_datos_select) {
    state.cargando_datos_select = cargando_datos_select;
}

/**
 * Restablecer el valor por defecto del SGA
 */
export function restablecerSga(state) {
    state.selectedSga = defaultSga();
}

/**
 * Restablecer el valor por defecto de los pictogramas
 */
export function restablecerPictogramas(state) {
    state.pictogramas = pictos();
}

/**
 * Agrega true o false para mostrar pestañas en la seccion sistema de clasificacion
 */
export function activarOpciones(state, dato) {
    state.activar = dato
}

export function setGuardado(state, guardado) {
    state.guardado = guardado
}

export function setTabActivoSga(state, activo) {
    state.tabs_sga.activo = activo
}

/**
 * Setear los pictogramas en su data inicial.
 *
 * @param {*} state
 * @author Fernando Claros
 */
export function setDefaultDataToPictograms(state) {
    state.pictograms = defaultDataToPictograms();
}

/**
 * Mutación para cargar la informacion de los pictogramas.
 *
 * @param {*} state
 * @param {*} nextPictograms: Nuevos pictogramas del producto.
 * @author Fernando Claros
 */
export function setPictograms(state, nextPictograms) {
    state.pictograms = nextPictograms;
}

/**
 * Mutación para actualizar el estado de la palabra de advertencia.
 *
 * @param {*} state
 * @param {*} nextSignalWord
 * @author Fernando Claros
 */
export function setSignalWord(state, nextSignalWord) {
    state.signalWord = nextSignalWord;
}

/**
 * Mutación para actualizar el estado de la palabra de advertencia.
 *
 * @param {*} state
 * @param {*} nextSignalWord
 * @author Fernando Claros
 */
export function setWordSignalWord(state, word) {
        state.signalWord.word = word;
}

/**
 * Mutación para actualizar el estado ver mensaje de conformación para actualizar efectos a la salud.
 *
 * @param {*} state
 * @param {boolean} seeCHealthEffects
 * @author Fernando Claros
 */
export function setSeeCHealthEffects(state, seeCHealthEffects) {
    state.seeCHealthEffects = seeCHealthEffects;
}


